import React, { useEffect, useState } from 'react';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";

export const RedirectForm = ({ values = {}, onFieldsChange }) => {
    const [formValues, setFormValues] = useState({ path: values?.path || '' });

    const handleChange = (event) => {
        const { name, value } = event.target;
        const updated = { ...formValues, [name]: value };
        setFormValues(updated);
        onFieldsChange(updated); // <-- aquí sí llamas
    };
    
    return (
        <Box>
            <Grid container spacing={2} alignItems="center">
                <Grid size={{xs:12, sm:6}}>
                    <TextField
                        label={'Path'}
                        name={'path'}
                        value={formValues.path}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                </Grid>
            </Grid>
        </Box>
    );
};
